export type ElemType =
  | "EMPTY"
  | "NO"
  | "NC"
  | "P"
  | "N"
  | "COIL"
  | "COIL_NOT"
  | "SET"
  | "RESET"
  | "TON"
  | "TOF"
  | "TP"
  | "TONR"
  | "CTU"
  | "CTD"
  | "CTUD"
  | "SR"
  | "RS"
  | "BOOL"
  | "SELECT"
  | "PROGRAM"
  | "CMP"
  | "MOVE"
  | "MATH"
  | "WORD_LOGIC"
  | "LIMIT"
  | "CONVERT";

export const COIL_TYPES: ElemType[] = ["COIL", "COIL_NOT", "SET", "RESET"];
export const BOX_TYPES: ElemType[] = [
  "TON",
  "TOF",
  "TP",
  "TONR",
  "CTU",
  "CTD",
  "CTUD",
  "SR",
  "RS",
  "BOOL",
  "SELECT",
  "PROGRAM",
  "MOVE",
  "MATH",
  "WORD_LOGIC",
  "LIMIT",
  "CONVERT",
];

export interface Cell {
  type: ElemType;
  /** address (I0.0 / Q0.0 / M0.0 / MW10) or instance/output name */
  operand: string;
  /** timer preset / counter preset / block input A / MOVE source */
  preset?: string | undefined;
  /** compare / math / logic / conversion operator */
  op?: string | undefined;
  /** compare B / block input B */
  b?: string | undefined;
  /** third block input (for LIMIT, etc.) */
  c?: string | undefined;
  /** counter/timer reset address */
  reset?: string | undefined;
}

export interface Network {
  id: string;
  title: string;
  comment: string;
  rows: Cell[][];
  /** links[r][c] === true joins row r and r+1 at the left edge of column c */
  links: boolean[][];
}

export const COLS = 8;

export function emptyCell(): Cell {
  return { type: "EMPTY", operand: "" };
}
export function emptyRow(cols = COLS): Cell[] {
  return Array.from({ length: cols }, emptyCell);
}
export function newNetwork(n: number): Network {
  return {
    id: `net_${Math.random().toString(36).slice(2, 9)}`,
    title: `Network ${n}`,
    comment: "",
    rows: [emptyRow(), emptyRow()],
    links: [Array.from({ length: COLS + 1 }, () => false)],
  };
}

export interface DeviceInst {
  id: string;
  type: string;
  x: number;
  y: number;
  label: string;
  /** runtime + user state: on, pressed, coil, run, t, pos ... */
  state: Record<string, number | boolean | string>;
  props: Record<string, string>;
}

export interface Wire {
  id: string;
  /** "deviceId:terminalId" */
  from: string;
  to: string;
  color: string;
  /** Optional single draggable routing handle in panel/world coordinates. */
  control?: { x: number; y: number };
}

export interface Project {
  id: string;
  name: string;
  devices: DeviceInst[];
  wires: Wire[];
  networks: Network[];
  scanMs: number;
  updatedAt: number;
  /** symbolic names: { "I0.0": "START" } */
  tags?: Record<string, string>;
  /** snap devices to the grid while dragging */
  snap?: boolean;
  /** persisted canvas viewport */
  view?: { x: number; y: number; k: number };
}

export const WIRE_COLORS = [
  { id: "red", label: "أحمر", css: "#e0322c" },
  { id: "blue", label: "أزرق", css: "#2f6fd0" },
  { id: "black", label: "أسود", css: "#1d2129" },
  { id: "green", label: "أخضر", css: "#2f9e44" },
  { id: "yellow", label: "أصفر", css: "#e0b400" },
  { id: "brown", label: "بني", css: "#8a5a2b" },
];

export function wireColor(id: string) {
  return WIRE_COLORS.find((c) => c.id === id)?.css ?? "#1d2129";
}
